import Controller from '@ember/controller';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  store: service(),
  storeCache: service(),
  router: service(),
  flashMessages: service(),

  delete: task(function* () {
    let record = get(this, 'model.fundPermission');
    yield record.destroyRecord();
    this.storeCache.breakFindAllCache('admin/user-fund');

    // TODO: Eric - how to refresh the route
    this.router.refresh('admin').then(() => {
      this.router.transitionTo('admin.funds.fund');
    });
  }).drop(),
});
